import { render, staticRenderFns } from "./PageIndicatorBullets.vue?vue&type=template&id=25ccb44c&scoped=true&"
import script from "./PageIndicatorBullets.vue?vue&type=script&lang=js&"
export * from "./PageIndicatorBullets.vue?vue&type=script&lang=js&"
import style0 from "./PageIndicatorBullets.vue?vue&type=style&index=0&id=25ccb44c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ccb44c",
  null
  
)

component.options.__file = "PageIndicatorBullets.vue"
export default component.exports